import { getExperiment } from '@eventbrite/statsig';
import {
    DisplayAdFromUserLikesExperiment,
    IncreaseAdsInHomepageExperiment,
} from '../../../../types';

export function hasIncreasedAds() {
    const experiment = getExperiment(
        IncreaseAdsInHomepageExperiment.name,
        IncreaseAdsInHomepageExperiment.paramName,
        IncreaseAdsInHomepageExperiment.values.control,
    );

    return experiment === IncreaseAdsInHomepageExperiment.values.moreAds;
}

export function hasNewPersonalizedBucket() {
    const experiment = getExperiment(
        DisplayAdFromUserLikesExperiment.name,
        DisplayAdFromUserLikesExperiment.paramName,
        DisplayAdFromUserLikesExperiment.values.control,
    );

    return experiment === DisplayAdFromUserLikesExperiment.values.recentLikes;
}

export const INCREASED_REGULAR_TAB_AD_SLOTS = [1, 6, 9, 10];
